/* DRAW — small behaviours for the Draw sections. No dependencies; safe to load on every page. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- dialogs: menu drawer and pop-up ---------- */
  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else { d.setAttribute('open', ''); }
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-draw-open]');
    if (opener) { e.preventDefault(); openDialog(document.getElementById(opener.getAttribute('data-draw-open'))); return; }
    var closer = e.target.closest('[data-draw-close]');
    if (closer) { e.preventDefault(); closeDialog(closer.closest('dialog')); return; }
    // click on the backdrop closes
    if (e.target.matches && e.target.matches('dialog.dw-dialog')) closeDialog(e.target);
  });
  $$('dialog.dw-dialog').forEach(function (d) {
    d.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
  });

  /* ---------- product photo viewer ---------- */
  function zoomShow(d, i) {
    var slides = $$('.dw-lightbox__slide', d);
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) { s.hidden = n !== i; if (n === i) { var im = $('img', s); if (im) im.loading = 'eager'; } });
    d.setAttribute('data-index', i);
    var c = $('[data-draw-zoom-count]', d); if (c) c.textContent = (i + 1) + ' / ' + slides.length;
  }
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-draw-zoom]');
    if (z) {
      var d = document.getElementById(z.getAttribute('data-draw-zoom-target'));
      if (!d) return;
      var slides = $$('.dw-lightbox__slide', d);
      var idx = 0;
      slides.forEach(function (s, n) { if (s.getAttribute('data-id') === z.getAttribute('data-draw-zoom')) idx = n; });
      zoomShow(d, idx); openDialog(d); return;
    }
    var st = e.target.closest('[data-draw-zoom-step]');
    if (st) { var dl = st.closest('dialog'); zoomShow(dl, Number(dl.getAttribute('data-index') || 0) + Number(st.getAttribute('data-draw-zoom-step'))); }
  });
  document.addEventListener('keydown', function (e) {
    var d = $('dialog[data-draw-lightbox][open]');
    if (!d) return;
    if (e.key === 'ArrowRight') zoomShow(d, Number(d.getAttribute('data-index') || 0) + 1);
    if (e.key === 'ArrowLeft') zoomShow(d, Number(d.getAttribute('data-index') || 0) - 1);
  });
  $$('dialog[data-draw-lightbox]').forEach(function (d) {
    var x0 = null;
    d.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    d.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) zoomShow(d, Number(d.getAttribute('data-index') || 0) + (dx < 0 ? 1 : -1));
    });
    // clicking the dark area around the photo closes the viewer
    d.addEventListener('click', function (e) { if (e.target.classList && (e.target.classList.contains('dw-lightbox__track') || e.target.classList.contains('dw-lightbox__slide'))) closeDialog(d); });
  });

  /* ---------- floating header: dark logo/icons over light backgrounds, light over dark ---------- */
  (function () {
    var wrap = $('[data-draw-adaptive]');
    if (!wrap || !document.elementsFromPoint) return;
    var targets = $$('[data-draw-tone-target]', wrap);
    var LIGHT = { linen: 1, raised: 1, citron: 1, paper: 1 };
    function toneAt(x, y) {
      var stack = document.elementsFromPoint(x, y);
      for (var i = 0; i < stack.length; i++) {
        var el = stack[i];
        if (wrap.contains(el)) continue;
        var tag = el.tagName;
        if (tag === 'IMG' || tag === 'VIDEO' || tag === 'PICTURE' || tag === 'IFRAME') return 'dark';
        var t = el.closest('[data-draw-tone], [data-draw-theme]');
        if (t && !wrap.contains(t)) {
          if (t.hasAttribute('data-draw-tone')) return t.getAttribute('data-draw-tone');
          return LIGHT[t.getAttribute('data-draw-theme')] ? 'light' : 'dark';
        }
        if (tag === 'BODY' || tag === 'HTML' || tag === 'MAIN') return 'light';
        var bg = window.getComputedStyle(el).backgroundColor;
        var m = bg && bg.match(/rgba?\(([\d.]+), ([\d.]+), ([\d.]+)(?:, ([\d.]+))?/);
        if (m && (m[4] === undefined || Number(m[4]) > 0.5)) {
          var lum = 0.299 * m[1] + 0.587 * m[2] + 0.114 * m[3];
          return lum > 150 ? 'light' : 'dark';
        }
      }
      return 'light';
    }
    var queued = false;
    function update() {
      queued = false;
      targets.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (!r.width) return;
        el.setAttribute('data-tone', toneAt(r.left + r.width / 2, r.top + r.height / 2));
      });
    }
    function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    update();
  })();

  /* ---------- basket icon: open Atelier's cart drawer when the theme uses one ---------- */
  document.addEventListener('click', function (e) {
    var cart = e.target.closest('[data-draw-cart]');
    if (!cart) return;
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.toggle === 'function') { e.preventDefault(); drawer.toggle(); }
    else if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(); }
    // otherwise the link goes to /cart
  });

  function refreshCount() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-draw-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.setAttribute('data-count', c.item_count); }); })
      .catch(function () {});
  }
  // keep the Draw header count in step with Atelier's cart drawer
  ['cart:update', 'cart:updated', 'cart-update'].forEach(function (ev) { document.addEventListener(ev, refreshCount); });

  /* ---------- add both oils at once (bread-basket band) ---------- */
  $$('form[data-draw-add-many]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var ids = $$('[data-draw-item]', form).map(function (i) { return { id: Number(i.value), quantity: 1 }; });
      if (ids.length < 2 || !window.fetch) return; // fall back to the normal single add
      e.preventDefault();
      var btn = $('button[type="submit"]', form); if (btn) btn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ids })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      }).catch(function () { if (btn) btn.disabled = false; form.submit(); });
    });
  });

  /* ---------- quantity steppers ---------- */
  $$('[data-draw-qty]').forEach(function (q) {
    var input = $('input', q);
    $$('button[data-step]', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-step'))));
        input.value = n;
      });
    });
  });

  /* ---------- variant picker on the product page ---------- */
  $$('form[data-draw-product-form]').forEach(function (form) {
    var idInput = $('[data-draw-variant-id]', form);
    var price = $('[data-draw-price]');
    var title = $('[data-draw-variant-title]');
    $$('input[name="draw-variant"]', form).forEach(function (r) {
      r.addEventListener('change', function () {
        idInput.value = r.value;
        if (price) price.textContent = r.getAttribute('data-price');
        if (title) title.textContent = ' · ' + r.getAttribute('data-title');
        var url = new URL(window.location.href); url.searchParams.set('variant', r.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  });

  /* ---------- notes (FAQ): sections + search ---------- */
  $$('[data-draw-notes]').forEach(function (root) {
    var groups = $$('[data-draw-group]', root);
    var buttons = $$('[data-draw-group-btn]', root);
    var search = $('[data-draw-notes-search]', root);
    var empty = $('[data-draw-notes-empty]', root);
    if (!groups.length) return;
    function showGroup(id) {
      groups.forEach(function (g) { g.hidden = g.getAttribute('data-draw-group') !== id; $$('[data-draw-q]', g).forEach(function (q) { q.hidden = false; }); });
      buttons.forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-draw-group-btn') === id ? 'true' : 'false'); });
      if (empty) empty.hidden = true;
    }
    buttons.forEach(function (b) { b.addEventListener('click', function () { if (search) search.value = ''; showGroup(b.getAttribute('data-draw-group-btn')); }); });
    if (search) search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      if (!q) { showGroup((buttons[0] && buttons[0].getAttribute('data-draw-group-btn')) || groups[0].getAttribute('data-draw-group')); return; }
      var any = false;
      groups.forEach(function (g) {
        var hits = 0;
        $$('[data-draw-q]', g).forEach(function (d) { var hit = d.textContent.toLowerCase().indexOf(q) > -1; d.hidden = !hit; if (hit) hits++; });
        g.hidden = hits === 0; if (hits) any = true;
      });
      buttons.forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      if (empty) empty.hidden = any;
    });
    // open the group named in the URL hash (e.g. /pages/notes#shipping), else the first
    var start = buttons[0] && buttons[0].getAttribute('data-draw-group-btn');
    var h = decodeURIComponent((window.location.hash || '').slice(1)).toLowerCase();
    buttons.forEach(function (b) { if (h && b.textContent.toLowerCase().indexOf(h) > -1) start = b.getAttribute('data-draw-group-btn'); });
    if (start) showGroup(start);
  });

  /* ---------- contact tabs ---------- */
  $$('[data-draw-tabs]').forEach(function (root) {
    var list = $('[data-draw-tablist]', root);
    var tabs = $$('[data-draw-tab]', root);
    var panels = $$('[data-draw-panel]', root);
    if (!list || !tabs.length) return;
    list.hidden = false;
    function select(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-draw-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-draw-panel') !== name; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-draw-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        select(next.getAttribute('data-draw-tab'), true);
      });
    });
    var wantStock = /DrawContactStock/.test(window.location.hash) || /stockist/i.test(window.location.hash);
    select(wantStock ? 'stock' : 'cook');
  });

  /* ---------- email pop-up: once per visitor, after a pause ---------- */
  var pop = $('[data-draw-popup]');
  if (pop) {
    var justPosted = /DrawPopupForm/.test(window.location.hash) || $('[data-draw-popup-done]', pop);
    if (pop.getAttribute('data-preview') === 'true' || justPosted) {
      openDialog(pop);
    } else if (!store.get('draw-popup-seen')) {
      var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 8) * 1000;
      setTimeout(function () {
        if ($('dialog[open]')) return;
        openDialog(pop);
        store.set('draw-popup-seen', '1');
      }, delay);
    }
  }
})();
